import React from 'react';

import { useForm } from 'react-hook-form';

import { Box, Button, MenuItem, Stack, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';

import { Input, Select } from '~/components/Common/Forms/fields';

import { SUPPLIER_NAMES } from '~/consts/bedbank';

import { toTitleCase } from '~/utils/toTitleCase';

interface Props {
  isPulling: boolean;
  handleSubmit: (supplier: string, externalId: string) => void;
}

function PullContent(props: Props) {
  const { control, handleSubmit } = useForm({
    defaultValues: {
      externalId: null,
      supplier: null,
    },
    mode: 'onBlur',
  });

  return (
    <Stack direction="column" spacing={2}>
      <Box>
        <Typography variant="h6">Pull Content</Typography>
      </Box>
      <Box>
        <form onSubmit={handleSubmit((data) => props.handleSubmit(data.supplier, data.externalId))}>
          <Grid spacing={2} container mb={2}>
            <Grid size={{ md: 4 }}>
              <Input fullWidth control={control} muiLabel="Enter External Id" name="externalId" />
            </Grid>
            <Grid size={{ md: 2 }}>
              <Select control={control} name="supplier" muiLabel="Supplier">
                {SUPPLIER_NAMES.map((supplier) => (
                  <MenuItem key={supplier} value={supplier}>
                    {toTitleCase(supplier)}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            <Grid size={{ md: 2 }}>
              <Button type="submit" variant="contained" disabled={props.isPulling}>
                Pull
              </Button>
            </Grid>
          </Grid>
        </form>
      </Box>
    </Stack>
  );
}

export default PullContent;
